import {
  areIntervalsOverlapping,
  endOfDay,
  format,
  parse,
  startOfDay,
} from 'date-fns';

import { Enrollment } from '@/features/recommendations/types/enrollments';

export const generateDateArray = (startDate: Date, endDate: Date): Date[] => {
  const dates: Date[] = [];
  const currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    dates.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
};

export const formatDateForKey = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};

export const parseIsoDateToLocal = (isoDate: string): Date => {
  // the iso date is used in URL query params of report pages, so we need to parse it to a local date
  return parse(isoDate, 'yyyy-MM-dd', new Date());
};

export const parseLocalDateRangeToUtcIso = (
  startDate: Date,
  endDate: Date
): { startDate: string; endDate: string } => {
  const startDateUtc = startOfDay(startDate).toISOString();
  const endDateUtc = endOfDay(endDate).toISOString();
  // we convert the local date to utc iso string before sending it to the server
  return {
    startDate: startDateUtc,
    endDate: endDateUtc,
  };
};

export function filterEnrollmentsByDateRange(
  enrollments: Enrollment[],
  startDate: Date,
  endDate: Date
): Enrollment[] {
  const maxAvailableDate = new Date(8640000000000000);

  return enrollments.filter((enrollment) => {
    if (!enrollment.beginDate) return false;

    const enrollmentBeginDate = startOfDay(new Date(enrollment.beginDate));
    const enrollmentEndDate = enrollment.endDate
      ? endOfDay(new Date(enrollment.endDate))
      : maxAvailableDate;

    return areIntervalsOverlapping(
      {
        start: enrollmentBeginDate,
        end: enrollmentEndDate,
      },
      { start: startDate, end: endDate },
      { inclusive: true }
    );
  });
}
